/**
 * Detect low-power / small-screen contexts where continuous GPU work
 * (WebGPU, mesh gradients, autoplay video) should be skipped or simplified.
 */
export function prefersLiteEffects() {
  if (typeof window === 'undefined') return true;

  try {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return true;
    }

    const saveData = navigator.connection?.saveData === true;
    if (saveData) return true;

    const coarsePointer = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    const narrowViewport = window.matchMedia('(max-width: 900px)').matches;
    if (coarsePointer || narrowViewport) return true;

    const lowMemory =
      typeof navigator.deviceMemory === 'number' && navigator.deviceMemory <= 4;
    const lowCpu =
      typeof navigator.hardwareConcurrency === 'number' &&
      navigator.hardwareConcurrency <= 4;
    if (lowMemory && lowCpu) return true;
  } catch {
    return true;
  }

  return false;
}

export function isNarrowViewport() {
  if (typeof window === 'undefined') return true;
  try {
    return window.matchMedia('(max-width: 900px)').matches;
  } catch {
    return true;
  }
}
